<template>
  <div class="d-flex flex-column ga-3">
    <div
      v-for="suggestion in suggestions"
      :key="suggestion.trait_id"
      class="ai-suggestion-row"
    >
      <div class="d-flex align-center ga-2 flex-wrap">
        <v-chip
          size="small"
          :variant="isSelected(suggestion.trait_id) ? 'flat' : 'outlined'"
          :color="isSelected(suggestion.trait_id) ? 'primary' : undefined"
          :prepend-icon="
            isSelected(suggestion.trait_id)
              ? 'mdi-check'
              : traitsStore.getTraitIcon(suggestion.trait_id)
          "
        >
          {{ traitName(suggestion.trait_id) }}
        </v-chip>
        <span class="text-caption text-medium-emphasis">{{
          suggestion.reason
        }}</span>
      </div>
      <div
        v-if="!isSelected(suggestion.trait_id)"
        class="d-flex ga-2 mt-2 ai-suggestion-actions"
      >
        <v-btn
          color="primary"
          variant="flat"
          class="flex-grow-1"
          prepend-icon="mdi-plus"
          @click="$emit('accept', suggestion.trait_id)"
        >
          Toevoegen
        </v-btn>
        <v-btn variant="text" @click="$emit('reject', suggestion.trait_id)">
          Afwijzen
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * The traits section of the AI-check. Accepting adds the trait to the report like
 * the normal picker does; nothing is saved until the report is saved.
 */
import { useTraitsStoreRefactor } from "@/stores/traitsStoreRefactor";

const props = defineProps({
  // [{ trait_id, reason }]
  suggestions: { type: Array, default: () => [] },
  // Trait ids currently on the report
  selectedIds: { type: Array, default: () => [] },
});

defineEmits(["accept", "reject"]);

const traitsStore = useTraitsStoreRefactor();

function isSelected(traitId) {
  return props.selectedIds.includes(traitId);
}

function traitName(traitId) {
  return traitsStore.getTraitById(traitId)?.name || `Kenmerk ${traitId}`;
}
</script>
